module.exports = __webpack_public_path__ + "static/media/html_page.e03e790e.ico";